import { AnimatedMessaging } from 'signup-components/styles/MessagingAnimations.styles';
import { BlobProfileName } from '../blob-messaging/blob/Blob.styles';
import { ImageBlob } from '../blob-messaging/ImageBlob';
import { useOnImageLoaded } from '../images/useOnImageLoaded';
import { OptionalFormattedMessage } from '../views-components/OptionalFormattedMessage';
import { BaseMessageCaption } from './BaseMessageCaption';
import { getMessage } from './MESSAGE';
import { isTransitionAndAnimationsDisabled } from '../selenium/seleniumFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BlobProfile = ({
  messageKey
}) => {
  const {
    imageUrl
  } = getMessage(messageKey);
  const {
    imageLoaded,
    handleImageLoaded
  } = useOnImageLoaded(imageUrl);
  const renderProfile = () => {
    return /*#__PURE__*/_jsxs("div", {
      className: "text-center m-top-8",
      children: [/*#__PURE__*/_jsx(BlobProfileName, {
        children: /*#__PURE__*/_jsx(OptionalFormattedMessage, {
          message: `message.${messageKey}.name`
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "m-top-1",
        children: [/*#__PURE__*/_jsx(OptionalFormattedMessage, {
          message: `message.${messageKey}.jobTitle`
        }), /*#__PURE__*/_jsx(OptionalFormattedMessage, {
          message: `message.${messageKey}.office`
        })]
      })]
    });
  };
  return /*#__PURE__*/_jsx(AnimatedMessaging, {
    disable: isTransitionAndAnimationsDisabled(),
    loaded: imageLoaded,
    children: /*#__PURE__*/_jsxs(BaseMessageCaption, {
      messageKey: messageKey,
      children: [/*#__PURE__*/_jsx(ImageBlob, {
        messageKey: messageKey,
        onImageLoaded: handleImageLoaded
      }), renderProfile()]
    })
  });
};
export default BlobProfile;